export const productFiltersNames = {
  initialProductPeriod: 'Initial Product Period',
  rateType: 'Rate Type',
};
